document.documentElement.classList.add('velcrano-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.vel-faq details').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      item.parentElement?.querySelectorAll('details[open]').forEach((other) => {
        if (other !== item) other.removeAttribute('open');
      });
    });
  });
});


